export enum Role {
  ADMIN = 'Admin',
  INVITED = 'Invited',
  
}
